import { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import Select from 'react-select';
import useDataBean from '../../../../core/services/dataBean/useDataBean';
import { _TypeNovelty } from '../../../../core/services/dataBean/EntityCatalog';

interface Props {
    idSelector: number;
    onChange: any;
    label?: string;
    returnType?: "ID" | "Object";
}

export const SelectTypeNovelty = ({ idSelector, onChange, label, returnType = "ID" }: Props) => {
    const { instance, bean, setBean, lista, setLista } = useDataBean(_TypeNovelty);
    const [selectedOption, setSelectedOption] = useState<any>(null);

    useEffect(() => {
        getLista();
    }, []);

    useEffect(() => {
        if (idSelector && lista.length > 0) {
            const found = lista.find(item => item.DataBeanProperties.IDTypeNovelty === idSelector);
            if (found) {
                setSelectedOption({
                    value: found.DataBeanProperties.IDTypeNovelty,
                    label: found.DataBeanProperties.EntityName,
                    item: found
                });
            }
        }
    }, [idSelector, lista]);

    const getLista = () => {
        instance.getTypeNoveltyCatalogPorPropiedades({ State: 1 }, null).then(
            (resp: any) => {
                resp.forEach(element => {
                    element.DataBeanProperties.EntityName = `${element.DataBeanProperties.Code ?? "N/P"} - ${element.DataBeanProperties.Name}`
                });

                setLista(resp);
            }).catch(err => toast.error(err));
    };

    const handleChange = (option: any) => {
        setSelectedOption(option);
        if (!option) {
            if (onChange)
                onChange(returnType === "Object" ? {} : null);
        } else {

            if (onChange) {
                onChange(returnType === "Object" ? option.item.DataBeanProperties : option.value);
            }
        }
    };

    const options = lista.map((item: any) => ({
        value: item.DataBeanProperties.IDTypeNovelty,
        label: item.DataBeanProperties.EntityName,
        item: item
    }));

    return (
        <div>
            {label !== " " && (
                <label>{label || "Tipos de Novedades"}</label>
            )}
            <Select
                options={options}
                value={selectedOption}
                onChange={handleChange}
                isClearable
                placeholder="Selecciona un Tipo de Novedad..."
                noOptionsMessage={() => "Sin coincidencias"}
            />
        </div >
    );
};
